export const WOOLSTORE_LABELS = ['PGGW Chch', 'PGGW Mosgiel', 'PGGW Invercargill', 'PGGW Napier']
